let prometheus_username = "b25laG9tZQ==";
let prometheus_password = "UGFzc3dvckQ=";

var metrics = "https://" + Buffer.from(prometheus_username,'base64').toString() + ":" + Buffer.from(prometheus_password,'base64').toString() + "@metrics.1home.io/graph?g0.tab=0";

module.exports = {
	username: [
        "bWF0aWphSg==", // matijaJ
        "emFuUA==", // zanP
        "cm9r", // rok
        "bmlrYQ==", // nika
        "Ymxheg==" // blaz
    ],
	password: [
        "aGVoZTEyMw==", // matijaJ
        "bmF6MzQ1Ng==", // zanP
        "cHJldm9sc2VrMTIz", // rok
        "YmVyZ2FudDEyMw==", // nika
        "a29sYXIxMjM=" // blaz
    ],
	token: "azertyuiop",
	metrics: metrics,
	refreshInterval: 20000, // in ms
	wsServer: "wss://skytalker.1home.io/websocket" // "ws://localhost:6970"
}



// WEBPACK FOOTER //
// ./src/config/config.js